// src/components/ImpersonationBanner.js
//
// Persistent banner shown on every page while a platform admin is
// impersonating an organizer. Deliberately impossible to miss or
// dismiss without actually ending the session -- there's no close (X)
// button, only "Stop impersonating".

import React, { useState } from 'react';
import { stopImpersonating } from '../services/api';

function ImpersonationBanner({ user, onStopImpersonating }) {
    const [stopping, setStopping] = useState(false);
    const [error,    setError]    = useState('');

    if (!user || !user.impersonating) return null;

    const handleStop = async () => {
        setStopping(true);
        setError('');
        try {
            const res = await stopImpersonating();
            onStopImpersonating(res.data);
        } catch {
            setError('Failed to stop impersonating. Try again.');
        } finally {
            setStopping(false);
        }
    };

    return (
        <div className="bg-yellow-500 text-gray-950 px-4 py-2 flex items-center justify-between gap-3 text-sm font-bold">
            <span>
                Viewing as <span className="underline">{user.name}</span>
                {user.real_admin_name && <> — you are {user.real_admin_name}</>}
                {error && <span className="ml-3 font-normal text-red-900">{error}</span>}
            </span>
            <button
                onClick={handleStop}
                disabled={stopping}
                className="bg-gray-950 text-yellow-400 hover:bg-gray-900 disabled:opacity-50 px-3 py-1 rounded-lg text-xs transition-colors">
                {stopping ? 'Ending…' : 'Stop impersonating'}
            </button>
        </div>
    );
}

export default ImpersonationBanner;